import React from 'react';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader, FileInput } from '@smartplatform/ui';

const EditRecipients = ({ match, rootPath, tabName }) => {
	const { id, rid } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'AwardRecipient', id: rid, options, tabName });

	if (!record) {
		return <Loader />;
	}
	const beforeSave = record => {
		record.awardId = id;
	};

	const onSave = () => {
		store.history.push(`${rootPath}/${id}/awardrecipients`);
	};

	return (
		<>
			<Title record={record} name="Получатель награды" />

			<Form record={record} rootPath={`${rootPath}/${id}`} beforeSave={beforeSave} onSave={onSave}>
				<Field property="name" label="Имя получателя" />
				<Field relation="year" property="name" label="Год присуждения" />
				<Field property="order" label="Приказ о назначении">
					<FileInput />
				</Field>
			</Form>
		</>
	);
};

export default withRouter(EditRecipients);
